// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_oSp","cls2":"RelatedPapers-cls2_qSL RelatedPapers-cls1_oSp"};